import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ChatReplyModel } from '@models/chat-reply.model'
import MainConfig from '../../../../config/main'

@Component({
    selector: 'app-chat-thread',
    templateUrl: './chat-thread.component.html',
    styleUrls: ['./chat-thread.component.css'],
})
export class ChatThreadComponent implements OnInit {

    @Input() isPatient = false
    @Input() replyModel: ChatReplyModel
    @Output() _onReact: EventEmitter<any> = new EventEmitter<any>()
    public enableReact: boolean

    reactIndex = 0

    className: string

    constructor() {
        this.enableReact = MainConfig.ENABLE_CHAT_REACTION
    }

    ngOnInit() {
        if ((this.isPatient && this.replyModel.isPatient) || (!this.isPatient && !this.replyModel.isPatient)) {
            this.className = 'my-thread'
        }

        if (this.replyModel.isPatient) {
            this.reactIndex = this.replyModel.clinicReact
        } else {
            this.reactIndex = this.replyModel.patientReact
        }
    }

    onReact(event: number) {
        this.reactIndex = event
        this._onReact.emit({
            id: this.replyModel._id,
            patientReact: this.replyModel.patientReact,
            clinicReact: this.replyModel.clinicReact,
        })
    }

    toHTML(input): any {
        return new DOMParser().parseFromString(input, 'text/html').documentElement.textContent
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat-thread/chat-thread.component.ts